function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-303 -823)",
  fill: "#f00",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(303 823)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.41 0c-1.7949 7.0455-4.3077 8.8068-10.41 10.92v4.9318l12.923 15.148v-4.5795c5.3846-1.7614 8.6154-5.6364 10.769-10.216l-13.282-16.205zm2.8718 31c6.8205-1.7614 11.487-3.5227 13.641-4.5795v-3.864c-3.3204 2.5968-9.6502 6.2382-13.641 7.739v0.70455zm0.71795-29.239l-0.67308 0.66051 10.926 13.331c0.16587 0.20379 0.20206 0.50121 0.089744 0.73759-2.1871 4.6504-5.5335 8.782-11.061 10.634l0.0112 0.79261c5.7436-1.4091 10.04-6.429 13.989-11.009l-13.282-15.148h1.79e-5zm-2.6923 3.4016l2.8718 3.1705c0.18177 0.20342 0.22762 0.5139 0.11218 0.75959-1.486 3.2811-3.4491 5.2206-6.4279 6.6822-0.2819 0.13957-0.65586 0.068059-0.86376-0.16511l-3.2308-3.5227c-0.32048-0.35372-0.12668-1.013 0.33654-1.1449 3.472-1.0221 4.6025-2.1378 6.0016-5.5703 0.4177-0.53437 0.6729-0.55015 1.2003-0.20916zm-0.37017 1.7173c-1.2246 2.5547-2.7824 4.0448-5.4071 5.0199l2.1538 2.3448c2.3335-1.2351 3.8392-2.7333 5.0929-5.3281l-1.8397-2.0366zm15.369 12.241c-3.3225 3.7833-8.2561 8.2237-13.024 9.7646v0.70455c5.3846-1.4091 10.41-5.2841 14.718-8.8068l-1.6939-1.6623z"
}))));

function SvgIconBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon-book.48db848c.svg";
export { ForwardRef as ReactComponent };